import { api, ApiError } from "@/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useDeletePromptById() {
  const queryClient = useQueryClient();

  return useMutation<unknown, ApiError, { promptId: string }>({
    mutationFn: ({ promptId }) => api.prompts.promptId.delete(promptId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["GET", "prompts"] });
      queryClient.invalidateQueries({
        queryKey: ["GET", "promptDetails", variables.promptId],
      });
    },
  });
}
